import getLegalPersonEmpty from "@/components/Form/PessoaJuridica/get_legal_person_empty";

export const getPagination = ({ pagination }) => pagination;
export const parceiro_empty = () => ({
  plano_exitos_id: null,
  plano_padrao_id: null,
  pessoa_juridica: { ...getLegalPersonEmpty },
  ativo: true,
  urls: [""],
  login_integrado: false,
  apenas_acesso_exclusivo: false,
});
